import { render } from "./GlobalSearchParams.vue?vue&type=template&id=417a1fb2"
import script from "./GlobalSearchParams.vue?vue&type=script&lang=ts"
export * from "./GlobalSearchParams.vue?vue&type=script&lang=ts"
script.render = render

export default script